/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import {
  type ProductShelfACESResultsModel,
  type ProductShelfResultsModel,
} from '@/api/types/browse-search-types';

export type MakeModelYearPageType = 'ShopByMake' | 'ShopByModel' | 'ShopByYear' | null;

export const getShopByType = (results: ProductShelfResultsModel): MakeModelYearPageType =>
  results.make
    ? results.model
      ? results.year
        ? 'ShopByYear'
        : 'ShopByModel'
      : 'ShopByMake'
    : null;

export const getACESShopByType = (results: ProductShelfACESResultsModel): MakeModelYearPageType =>
  results.makeName || results.makeId
    ? results.modelName || results.modelId
      ? results.year
        ? 'ShopByYear'
        : 'ShopByModel'
      : 'ShopByMake'
    : null;
